import { make } from 'vuex-pathify';
import { DelinquencyActionsService } from '@/modules/global-settings/delinquency/services/delinquency-actions.service';
import Logger from '@/lib/logger.js';

const service = new DelinquencyActionsService();

export const state = {
  delinquencyActions: [],
  delinquencyAction: {},
  delinquencyParticipants: [
    'co-borrower',
    'guarantor',
    'co-maker',
    'employer',
    'co-signer'
  ],
  delinquencyActionModes: ['manual'],
  delinquencyActionsVariableBasis: [
    'principal balance',
    'principal & interest balance',
    'principal arrears',
    'principal & interest arrears'
  ]
};

export const mutations = {
  ...make.mutations(state)
};

export const getters = {
  ...make.getters(state)
};

export const actions = {
  /**
   * Retrieve the list of delinquency control actions.
   */
  async getActions({ commit }) {
    try {
      const { data } = await service.getActions();
      commit('SET_DELINQUENCY_ACTIONS', data);
      return data;
    } catch (error) {
      Logger.error('Getting Delinquency Actions');
      throw error;
    }
  },

  async getPaginatedActions(_, params) {
    try {
      const { data } = await service.getPaginatedActions(params);
      return data; 
    } catch (error) {
      Logger.error('Getting Paginated Delinquency Actions', error);
      return { data: [], total: 0 }; 
    }
  },

  async getActionById({ commit }, id) {
    try {
      const { data } = await service.getActionById(id);
      commit('SET_DELINQUENCY_ACTION', data);
      return data;
    } catch (error) {
      Logger.error('Getting Delinquency Action by ID');
      throw error;
    }
  },

  async createAction(_, payload) {
    try {
      const { data } = await service.createAction(payload);
      return data;
    } catch (error) {
      Logger.error('Creating Delinquency Action');
      throw error;
    }
  },

  async updateAction(_, payload) {
    try {
      const { data } = await service.updateAction(payload);
      return data;
    } catch (error) {
      Logger.error('Updating Delinquency Action');
      throw error;
    }
  },

  async removeAction(_, id) {
    try {
      const { data } = await service.removeAction(id);
      return data;
    } catch (error) {
      Logger.error('Removing Delinquency Action');
      throw error;
    }
  },

  async updateActionConfiguration(_, { id, config }) {
    try {
      const { data } = await service.updateActionConfiguration(id, config);
      return data;
    } catch (error) {
      Logger.error('Updating Delinquency Action Configuration');
      throw error;
    }
  },

  async reorderActions(_, { id, payload }) {
    try {
      const { data } = await service.reorderActions(id, payload);
      return data;
    } catch (error) {
      Logger.error('Reordering Delinquency Actions');
      throw error;
    }
  },
  async setAllActiveStatus(_, { isActive }) {
    try {
      const { data } = await service.setAllActiveStatus({ isActive });
      return data;
    } catch (error) {
      Logger.error('Setting Delinquency Actions Active Status');
      throw error;
    }
  }
};
